import type { ReadonlyDeep } from 'type-fest';

import { invariant } from '@e-socna/utils';
import { MissionArchiveInfoInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import type { MissionStateForm_MissionArchiveInfo } from '../fragments/mission-archive-info.fragment';

export function missionArchiveInfoForm2ApiMapper(
  draft: Readonly<MissionStateForm_MissionArchiveInfo>,
): ReadonlyDeep<MissionArchiveInfoInput> {
  invariant(
    draft.archiveBinders.length > 0,
    'At least one archive binder is required',
  );
  invariant(
    !!draft.startDateForAnalytics,
    'Start date for analytics is missing',
  );
  invariant(!!draft.endDateForAnalytics, 'End date for analytics is missing');
  invariant(
    draft.startDateForAnalytics <= draft.endDateForAnalytics,
    'Start date for analytics must be before or equal to the end date',
  );
  invariant(
    draft.iHavedCheckedThatReportHasBeenUploaded,
    'Report checklist item is not confirmed',
  );
  invariant(
    draft.iHavedCheckedThatPlansHaveBeenUploaded,
    'Plans checklist item is not confirmed',
  );
  invariant(
    draft.iHavedCheckedThatQuotationHasBeenUploaded,
    'Quotation checklist item is not confirmed',
  );
  invariant(
    draft.iHavedCheckedThatHypothesisNotesHaveBeenUploaded,
    'Hypothesis notes checklist item is not confirmed',
  );

  return pruneInput(draft, MissionArchiveInfoInput);
}
